import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-ice px-3 py-4 sm:px-6" data-id="element-41" data-mp="1hd1nvzbcra01">
      <div className="mx-auto max-w-2xl" data-id="element-42" data-mp="1hdun8f7zex85">
        <h2 className="text-center text-[1.15rem] font-extrabold uppercase text-navy sm:text-[1.7rem]" data-id="element-43" data-mp="1ceqefpoyz1ic">
          Frequently asked questions
        </h2>
        <ul className="mt-2 space-y-1.5" data-id="element-44" data-mp="2a1h06e33ne7o">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="overflow-hidden rounded-md border border-navy/10 bg-white" data-id="element-45" data-mp="203stcps7yg95" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-2 px-2.5 py-2 text-left text-[0.8rem] font-bold text-navy transition-colors duration-150 ease-out hover:text-teal sm:text-[0.92rem]" data-id="element-46" data-mp="1v5839j6olcyf">
                  {f.q}
                  <ChevronDownIcon className={`h-4 w-4 shrink-0 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-47" data-mp="1pmbact25mtf9" />
                </button>
                {isOpen ? <p id={`faq-${i}`} className="px-2.5 pb-2 text-[0.78rem] leading-[1.35] sm:text-[0.88rem]" data-id="element-48" data-mp="11wz4a224j1h6">
                    {f.a}
                  </p> : null}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}